import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

export default function V2AudioDescribedToggle({ checked, onPreferenceChange }) {
  return (
    <div className="V2Container-adToggle">
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={(event) => onPreferenceChange(event.target.checked)}
            color="primary"
            name="audioDescribed"
            inputProps={{ 'aria-label': 'Audio described version' }}
          />
        }
        label="Audio Described Video"
      />
    </div>
  );
}
